<template>
    <v-container fluid>
        <v-card class="ma-2" outlined>
        <v-progress-linear indeterminate color="yellow darken-2" v-if="loading"></v-progress-linear>
            <v-card-title>
                <v-icon class="mr-1" color="green">mdi-cloud-question</v-icon>
                Quiz
                <v-spacer></v-spacer>
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
                <v-btn color="primary" dark class="ml-5 mt-3" @click="addNewQuiz">
                    + ADD
                </v-btn>
            </v-card-title>
    
            <!-- Dialog for confirm delete user -->
            <v-dialog v-model="dialogItem.deleteConfirmation" max-width="400px">
                <v-card>
                    <v-card-title class="text">{{ dialogItem.confirmText }}</v-card-title>
                    <v-card-actions v-if="dialogItem.confirmAction">
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="closeConfirmationDialog">OK</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                    <v-card-actions v-else>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="actionDeleteQuiz">Yes</v-btn>
                        <v-btn color="blue darken-1" text @click="closeConfirmationDialog">No</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <!-- table list -->
            <v-data-table v-if="quizList.length" :headers="headers" :items="quizList" :search="search" sort-by="no" :sort-desc="false" :footer-props="{ 'items-per-page-options': [10, 20, 30, 50, 100, -1] }" :options="options" :loading="loading">
                <template v-slot:[`item.actions`]="{ item }">
                    <v-icon class="mr-2" @click="editQuizAction(item)" title="Edit" v-if="isSuperAdmin || isAccessQuiz">
                        mdi-pencil
                    </v-icon>
                    <v-icon v-if="isSuperAdmin || isAccessQuiz" class="mr-2" @click="dialogDeleteQuiz(item)" title="Delete">
                        mdi-delete
                    </v-icon>
                </template>
            </v-data-table>
            <v-card-subtitle v-else>No item list</v-card-subtitle>
        </v-card>
    </v-container>
    </template>
    
    <script>
    import firebase from "firebase/compat/app";
    import "firebase/compat/auth";
    import {
        mapGetters
    } from "vuex";
    import getQuizList from "../data/getQuizList";
    import removeQuiz from "../data/removeQuiz";
    export default {
        name: 'QuizManagementList',
        metaInfo: {
            title: 'Quiz Management List'
        },
        data() {
            return {
                loading: false,
                search: "",
                options: {
                    itemsPerPage: 20,
                },
                headers: [
                    {
                        text: "No",
                        value: "no"
                    },
                    {
                        text: "Question",
                        value: "question"
                    },
                    {
                        text: "Actions",
                        value: "actions",
                        sortable: false,
                    },
                ],
                quizList: [],
    
                dialogItem: {
                    confirmAction: false,
                    confirmText: "Do you want to delete this quiz?",
                    deleteConfirmation: false,
                    deletedItemId: null,
                },
                dialogItemDefault: {
                    confirmAction: false,
                    confirmText: "Do you want to delete this quiz?",
                    deleteConfirmation: false,
                    deletedItemId: null,
                }
            };
        },
        created() {
            var vm = this;
            vm.$store.state.appTitle = "Thaisook Web Admin | Quiz";
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    vm.$store.dispatch("autoSignIn", user);
                    this.loading = true;
                    setTimeout(() => {
                        vm.initialize();
                    }, "1000");
                } else {
                    console.log("no user");
                }
            });
        },
        computed: {
            ...mapGetters([
                "loggedInUserId",
                "isAuthenticated",
                "isSuperAdmin",
                "isChallengeAdmin",
                "isAccessQuiz"
            ]),
        },
        methods: {
            initialize() {
                if (this.isSuperAdmin || this.isAccessQuiz) {
                    (async () => {
                        this.loading = true;
                        this.quizList = await getQuizList();
                        this.loading = false;
                    })();
                } else {
                    this.$router.push(`/dashboard`);
                }
            },
            // //dialog
            addNewQuiz() {
                this.$router.push(`/quiz-add`);
            },
            editQuizAction(item) {
                this.$router.push(`/quiz-edit/${item.id}`);
            },
    
            // //delete
            dialogDeleteQuiz(item) {
                this.dialogItem.deleteConfirmation = true; //show popup
                this.dialogItem.deletedItemId = item.id; //assign delete item id
    
                this.dialogItem.confirmAction = this.dialogItemDefault.confirmAction;
                this.dialogItem.confirmText = this.dialogItemDefault.confirmText;
            },
            actionDeleteQuiz() {
                (async () => {
                    await removeQuiz(this.dialogItem.deletedItemId);
                    this.dialogItem.confirmAction = true;
                    this.dialogItem.confirmText = "Done!";
    
                    this.dialogItem.deleteConfirmation = false;
                    this.dialogItem.deletedItemId = this.dialogItemDefault.deletedItemId; //assign delete item id
                    await this.initialize();
                })();
            },
            closeConfirmationDialog() {
                //To result default value
                this.dialogItem.deleteConfirmation = false;
                this.dialogItem.deletedItemId = this.dialogItemDefault.deletedItemId; //assign delete item id
                this.dialogItem.confirmAction = this.dialogItemDefault.confirmAction;
                this.dialogItem.confirmText = this.dialogItemDefault.confirmText;
            }
        },
    };
    </script>